import {useContext} from "react";

import {useCurrentUserContext} from "@/components/context/hooks.ts";
import {StatusPageTheme} from "@/lib/types/statuspages.ts";
import {LivePreviewPanel} from "@/pages/statuspages/statuspages-manage/components/LivePreviewPanel.tsx";
import {
  StatusPageContext,
  StatusPagePreviewStateContext,
} from "@/pages/statuspages/statuspages-manage/ManageStatusPageTabContainer.utils.tsx";
import {StatusPageThemePreview} from "@/pages/statuspages/tabs/design/ThemePreview/StatusPageThemePreview.tsx";

// The live preview embeds the consumption SPA, so it is only meaningful once the account is
// migrated to SPA serving. It also does not support the legacy theme. In every other case
// (account still on legacy serving, or a legacy-themed page) fall back to the lightweight static
// theme preview.
export const DesignPreviewPane = () => {
  const {statusPage} = useContext(StatusPageContext);
  const {previewOverrides} = useContext(StatusPagePreviewStateContext);
  const {user} = useCurrentUserContext();
  const theme = previewOverrides?.theme ?? statusPage.theme;
  const accountUsesSpa = !!user?.account?.status_pages_use_spa;

  if (theme === StatusPageTheme.LEGACY || !accountUsesSpa) {
    return (
      <div className={"d-flex flex-column gap-5"}>
        <span className={"pulseTextBodyBold"}>Preview</span>
        <StatusPageThemePreview
          name={(previewOverrides?.name ?? statusPage.name) || "My Status Page"}
          timezone={previewOverrides?.timezone ?? statusPage.timezone}
          textColor={previewOverrides?.custom_header_text_color_hex ?? statusPage.custom_header_text_color_hex}
          backgroundColor={previewOverrides?.custom_header_bg_color_hex ?? statusPage.custom_header_bg_color_hex}
        />
      </div>
    );
  }

  return <LivePreviewPanel statusPageId={statusPage.id} />;
};
